import cn from 'classnames/bind'

import styles from './quad-line-cell.scss'
import { isValueZero } from 'app/common/templates-next/table-template'

const cx = cn.bind(styles)

type Props = {
  line1: string
  line2: string
  line3: string
  line4: string
}

const QuadLineCell = ({ line1, line2, line3, line4 }: Props) => {
  return (
    <>
      <div className={cx(styles.line, { zero: isValueZero(line1) })}>{line1}</div>
      <div className={cx(styles.line, { zero: isValueZero(line2) })}>{line2}</div>
      <div className={cx(styles.line, { zero: isValueZero(line3) })}>{line3}</div>
      <div className={cx(styles.summary, { zero: isValueZero(line4) })}>{line4}</div>
    </>
  )
}

export default QuadLineCell
